import CustomDialog from 'widgets/component/CustomDialog';
import DataTableDetailOrder from 'widgets/customDialogComponentDetails/ComponentDialog';

const DialogsVinculation = ({
  isDialogOpenDetails,
  handleClose,
  orderVinculationDetailList,
  handleOpenPopUp,
  handleOpenSessionModal,
  extraAcceptButton,
  isDialogOpen,
  dialogMessage,
}) => (
  <>
    <CustomDialog
      fullWidth
      title={
        orderVinculationDetailList?.response === null
          ? 'No hay datos'
          : 'Detalle Órdenes de Vinculación'
      }
      content={
        <DataTableDetailOrder
          type='DetailsVinculationOrders'
          handleOpenPopUp={(action, rowId, sessions, transactionId) => {
            if (action === 'session' && sessions && transactionId) {
              handleOpenSessionModal(sessions, transactionId);
            } else {
              handleOpenPopUp(action, rowId);
            }
          }}
          response={orderVinculationDetailList?.response}
          idTransaction={orderVinculationDetailList?.response?.provider_type?.transaction_id}
          namePayment={orderVinculationDetailList?.response?.provider_type?.name}
          onClose={handleClose}
          openSessionModal={handleOpenSessionModal}
        />
      }
      open={isDialogOpenDetails}
      onClose={handleClose}
      maxWidth='md'
      extraButtons={[extraAcceptButton]}
    />
    <CustomDialog
      title='Mensaje'
      content={<p>{dialogMessage}</p>}
      open={isDialogOpen}
      onClose={handleClose}
      fullWidth
      maxWidth='sm'
      extraButtons={[extraAcceptButton]}
    />
  </>
);

export default DialogsVinculation;
